import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetRfidBadgeOrdersPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/rfid-badge-orders/get-rfid-badge-orders-paginated.form-validation';
import { GetRfidBadgeOrdersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/rfid-badge-orders/get-rfid-badge-orders-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { EmspBoRfidBadgeOrderStatusFilterController } from '../../emsp-bo-rfid-badge-order-status-filter/emsp-bo-rfid-badge-order-status-filter.controller';

const EmspBoRfidBadgeOrderListFilterFormStep1StatusFragment =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { control } = useFormContext<GetRfidBadgeOrdersPaginatedModel>();
    const { status } = useGetRfidBadgeOrdersPaginatedFormValidation();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Controller
        name="status"
        control={control}
        rules={status}
        render={({ field }) => {
          return (
            <EmspBoRfidBadgeOrderStatusFilterController
              selectedItemId={field.value}
              onChange={(value) => field.onChange(value ?? null)}
            />
          );
        }}
      />
    );
  };

export const EmspBoRfidBadgeOrderListFilterFormStep1Controller =
  (): React.JSX.Element => {
    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Stack
        direction="row"
        justifyContent="stretch"
        alignItems="stretch"
        flex={1}
        gap={GapEnum.M}>
        <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
          <EmspBoRfidBadgeOrderListFilterFormStep1StatusFragment />
        </Stack>
      </Stack>
    );
  };
